(function () {
  function normalizeDropbox(url) {
    if (!url) return url;
    var u = ("" + url).trim().replace(/&amp;/g, "&").split("#")[0];

    if (u.indexOf("dropbox.com") === -1 && u.indexOf("dl.dropboxusercontent.com") === -1) return u;

    u = u
      .replace("www.dropbox.com", "dl.dropboxusercontent.com")
      .replace("dropbox.com", "dl.dropboxusercontent.com");

    u = u.replace(/([?&])dl=(0|1)\b/g, "$1raw=1");

    if (!/[?&]raw=1\b/.test(u)) {
      u += u.indexOf("?") === -1 ? "?raw=1" : "&raw=1";
    }
    return u;
  }

  function forceMute(v) {
    if (!v) return;
    try { v.muted = true; } catch (e) {}
    try { v.volume = 0; } catch (e) {}
    try { v.defaultMuted = true; } catch (e) {}
  }

  function initHost(host) {
    if (!host || host.dataset.pvInit === "1") return;

    var video = host.querySelector("video");
    var url = host.getAttribute("data-url") || "";

    if (video) {
      var src = normalizeDropbox(url);
      if (src && video.getAttribute("src") !== src) {
        video.setAttribute("src", src);
        try { video.load(); } catch (e) {}
      }
      forceMute(video);

      video.addEventListener("volumechange", function () { forceMute(video); });
      video.addEventListener("play", function(){ host.classList.add("is-playing"); });
      video.addEventListener("pause", function(){ host.classList.remove("is-playing"); });
      video.addEventListener("ended", function(){ host.classList.remove("is-playing"); });
    }

    host.dataset.pvInit = "1";
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-pv-host]").forEach(function (host) {
      host.dataset.pvInit = "0"; // permitir re-init tras save
      initHost(host);
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-pv-toggle]");
    if (!btn) return;

    var host = btn.closest("[data-pv-host]");
    if (!host) return;

    var video = host.querySelector("video");
    if (!video) return;

    forceMute(video);

    if (video.paused) {
      var p = video.play();
      if (p && typeof p.then === "function") {
        p.then(function () { host.classList.add("is-playing"); }).catch(function () {});
      } else {
        host.classList.add("is-playing");
      }
    } else {
      video.pause();
      host.classList.remove("is-playing");
    }
  });

  initAll(document);

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:block:select", function (e) { initAll(e.target); });

  var obs = new MutationObserver(function () { initAll(document); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
